import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Form, Layout, Row, Typography, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { outOfNavRoutes } from '../../utils/constants/adminRoutes';
import Logo from '../../assets/images/logoanisenior.png';
import PasswordConfirmFields from './PasswordConfirmFields';

const { Title } = Typography;

/**
 * @component
 * Component for creating a password via email.
 * @param {object} props - Component props.
 * @param {Function} props.switchForm - Callback to switch form.
 * @returns {JSX.Element} The JSX element representing the ForgotPwdForm component.
 */
const PostPwdForm = () => {
  const { t } = useTranslation();
  const { urlToken } = useParams();
  const { dispatchAPI } = useAuthContext();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const postPwd = async (body) => {
    setLoading(true);
    try {
      await dispatchAPI('PATCH', {
        url: `users/post-pwd/${urlToken}`,
        body
      });
      message.success(t('login.post-pwd'));
      return navigate(outOfNavRoutes.LOGIN);
    } catch (e) {
      if (e) message.error(t('login.postPwdEmailError'));
      return setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    await postPwd(values);
  };

  return (
    <Layout className="login-layout">
      <Row>
        <Col
          xs={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 8 }}
          xl={{ span: 7 }}
          xxl={{ span: 7 }}
          className="login-form-col"
        >
          <img
            style={{
              width: 240,
              marginBottom: 56
            }}
            alt="Logo"
            src={Logo}
          />
          <Title className="login-title">{t(`login.title.post-pwd`)}</Title>
          <Form onFinish={handleSubmit}>
            <PasswordConfirmFields
              submitLabel={t('login.createPwd')}
              loading={isLoading}
            />
            <Form.Item>
              <Button
                type="link"
                block
                style={{ width: '100%' }}
                onClick={() => navigate(`${outOfNavRoutes.LOGIN}`)}
              >
                {t('buttons.back')}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Layout>
  );
};

export default PostPwdForm;
